import { ref } from '@vue/composition-api'
import { auth } from 'ui-common'
import repositories from '@/repositories'

export const useProfile = () => {
  const loadingProfile = ref(false)

  const getProfile = async () => {
    try {
      loadingProfile.value = true
      const res = await repositories.profile.getProfile()
      let profile = res.data
      if (!+profile.producer && profile.docInfo) {
        profile = profile.docInfo
      }
      auth.$state.profile = profile
    } catch (err) {} finally {
      loadingProfile.value = false
    }
  }

  return {
    loadingProfile,
    getProfile
  }
}
